import { render, staticRenderFns } from "./PIIDataSummary.vue?vue&type=template&id=054ee840&scoped=true&"
import script from "./PIIDataSummary.vue?vue&type=script&lang=js&"
export * from "./PIIDataSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054ee840",
  null
  
)

export default component.exports